import { searchClient, indexName } from '../../algolia-shared/config';

const appDom = document.querySelector('.js-illinois-made-block');
const categoryFilters = JSON.parse(appDom.dataset.categories);
const regionFilters = JSON.parse(appDom.dataset.regions);

const searchIndex = searchClient.initIndex(indexName);

const categoryFacets = (items) => {

    const filteredItems = [];
    for (const catID in items) {

        // eslint-disable-next-line
        if (parseInt(catID) === 0) {

            // eslint-disable-next-line
            continue;

        }

        const found = categoryFilters.find((filter) => {

            // eslint-disable-next-line
            return filter.category === parseInt(catID);

        });
        if (found) {

            filteredItems.push(found);

        }

    }
    return filteredItems.sort((a, b) => {

        return a.title.localeCompare(b.title);

    });

};

const pageSeoData = JSON.parse(appDom.dataset.pageMeta);

export {
    searchIndex,
    categoryFilters,
    regionFilters,
    pageSeoData,
    categoryFacets,
};
